import { createFileRoute, notFound } from '@tanstack/react-router';
import { canUseMockMode } from '@/lib/mock-mode';
import { previewQuery } from '@/services/content-preview';
import { ClientReviewPage } from '@/features/admin/draft-preview/client-review-page';

// Dreamwell staff only: a preview drawn as the client's full Review Content page (for demos). `?creator=` names the creator.
export const Route = createFileRoute('/_authed/admin/client-view/$previewId')({
  validateSearch: (search: Record<string, unknown>): { creator?: string } => (typeof search.creator === 'string' && search.creator.trim() ? { creator: search.creator.trim().slice(0, 80) } : {}),
  beforeLoad: ({ context: { user } }) => {
    if (!canUseMockMode(user.email)) throw notFound();
  },
  loader: ({ context: { queryClient }, params }) => queryClient.ensureQueryData(previewQuery(params.previewId)).catch(() => null),
  component: ClientView,
});

function ClientView() {
  const { previewId } = Route.useParams();
  const { creator } = Route.useSearch();
  return <ClientReviewPage previewId={previewId} creator={creator} />;
}
